/**
 * Validazione numero di telefono italiano (mobile).
 *
 * Pattern accettati:
 *   - "3xx xxxxxxx" o "3xxxxxxxxx" (9 o 10 cifre dopo 3)
 *   - "+39 3xx ..." o "+393xx..." (con prefisso internazionale)
 *
 * Non accettiamo fissi (02..., 06..., ...) perche' il flusso onboarding
 * richiede contatto mobile per SMS/WhatsApp (vedi /design/design.md §14).
 */

const PHONE_REGEX = /^(?:\+39\s?)?3\d{2}\s?\d{6,7}$/;

export function isValidPhoneIT(phone: string): boolean {
  if (typeof phone !== 'string') return false;
  return PHONE_REGEX.test(phone.trim());
}

/** Normalizza a formato compatto (+39XXXXXXXXXX). */
export function normalizePhoneIT(phone: string): string {
  const cleaned = phone.replace(/\s/g, '');
  if (cleaned.startsWith('+39')) return cleaned;
  return `+39${cleaned}`;
}
